@import url('./assets/fontawesome/css/all.min.css');

:host {
  line-height: 1;
}

.spw-icon.fa-solid,
.spw-icon.fa-solid:before {
  font-family: 'Font Awesome 6 Free';
}

.spw-icon.fa-brands,
.spw-icon.fa-brands:before {
  font-family: 'Font Awesome 6 Brands';
}

.spw-icon {
  font-size: inherit;
}
